/**
 * @description
 * Current version of the Gauzy API.
 *
 * @example
 * ```
 * import { version } from './version';
 *
 * console.log('Gauzy API version:', version);
 * ```
 *
 * @since 0.1.0
 */
export const version: string = require('./package.json').version;
